import { Controller } from "@hotwired/stimulus"

// Il bando cercato dalla ricerca in alto (/app/bandi?bando=<id>): la scheda scorre al centro della vista
// (el.scrollIntoView({ behavior: "smooth", block: "center" }) di Grants.js); l'anello ring-2 ring-oro lo mette il server.
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ behavior: "smooth", block: "center" })
  }
}
